import React from "react";

type Props = { content: string; } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export default function HtmlPreviewer({ content, className, ...rest}:  Props) {

  return (
    <div
      className="prose prose-h2:text-xl !max-w-full prose-h2:border-b-0"
      dangerouslySetInnerHTML={{ __html: content }}
      {...rest}
    />
  );
}
